import store, { NAMESPACES } from '@/store'
import { DEVICE_GETTERS } from '@/store/devices'

export function getPermissionsByDeviceId(deviceId: string): string[] {
  return store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_PERMISSIONS_BY_DEVICE_ID}`](
    deviceId
  ) as string[]
}
